<template>
  <div class="service-request-page-step1">
    <div class="service-request-page__top">
      <div class="service-request-page__head">
        <div class="service-request-page__input">
          <SearchField
            ref="SearchField"
            v-model="inputSearch"
            required
            :label="
              choiceSearch === 0
                ? getMain.form.city_id.label
                : getMain.form.dealer_id.label
            "
            @clickClearIcon="clearSearch"
            @clickSearchIcon="handleSearch"
          />
        </div>
        <div class="service-request-page__checkboxes">
          <div
            class="service-request-page__checkbox-inner"
            @click="onSearchCity"
          >
            <button
              class="service-request-page__checkbox"
              :class="{ active: choiceSearch === 0 }"
            >
              <div class="radio" />
              <span> {{ getMain.buttonSearchByCity }} </span>
            </button>
          </div>

          <div
            class="service-request-page__checkbox-inner"
            @click="onSearchDP"
          >
            <button
              class="service-request-page__checkbox"
              :class="{ active: choiceSearch === 1 }"
            >
              <div class="radio" />
              <span> {{ getMain.buttonSearchByDealer }} </span>
            </button>
          </div>

        </div>
        <button
          class="service-request-page__geo"
          @click="getCurrentGeoLocation"
        >
          <span>{{ getMain.tabs.tab2.labels.useMyLocation }}</span>
          <Geo2Icon />
        </button>
      </div>
      <BaseButton
        class="service-request-page__button"
        type="primary"
        :disabled="!form.dealerId"
        @click="submitForm"
      >
        {{ getMain.continueButtonText }}
      </BaseButton>
    </div>
    <hr v-show="showMap"/>
    <div v-show="showMap" class="service-request-page__inner">
      <div class="service-request-page-step1__list-column">
        <div
          v-show="error"
          class="service-request-page-step1__location-block-error"
        >
          {{ getMain.notFoundLabel }}
        </div>
        <div
          class="service-request-page-step1__search-results-list"
          :class="{ 'without-map': choiceSearch === 1 }"
        >
        <div
          v-for="(item, itemIndex) in items"
          :key="`item-${itemIndex}`"
          ref="$items"
          class="service-request-page-step1__search-results-list-item"
          :class="{
            'active': activeItemIndex === itemIndex
          }"
          @click="onMarkerClick(itemIndex,'list')"
        >
          <div
            class="service-request-page-step1__search-results-list-item-title"
          >
            <span
              class="service-request-page-step1__search-results-list-item-name"
              :title="item._source.name"
            >
              {{ item._source.name }}
            </span>
            <span
              class="service-request-page-step1__search-results-list-item-index"
            >
              {{ itemIndex + 1 }}
            </span>
          </div>
          <div
            v-if="getWorkshopAddress(item)"
            class="service-request-page-step1__search-results-info-description"
          >
            {{ getWorkshopAddress(item).addressLine1 }} {{ getWorkshopAddress(item).addressLine2 }}
          </div>

          <div
            v-if="item.workshopOpenDays"
            class="service-request-page-step1__schedule"
          >
            <div class="service-request-page-step1__schedule-title">
              {{ scheduleTitle }}
            </div>
            <div
              v-for="(line, lineIndex) in [...item.workshopOpenDays.split('\n')]"
              :key="`schedule-${itemIndex}-${lineIndex}`"
              class="service-request-page-step1__schedule-line"
            >
              <div v-html="line" />
            </div>
          </div>

          <div
            v-if="choiceSearch === 0"
            class="service-request-page-step1__search-results-list-item-distance"
          >
            <GeoIcon />
            {{
              getDistanceBetweenTwoPoints(
                {
                  lat: item._source.addresses[0].geoLocation.lat,
                  lon: item._source.addresses[0].geoLocation.lon
                },
                {
                  lat: currentGeoLocation.latitude,
                  lon: currentGeoLocation.longitude
                }
              )
            }}{{ getMain.tabs.tab2.labels.kilometer }}
          </div>
          <div v-else class="service-request-page-step1__search-results-list-item-empty-space"></div>

          <BaseButton
            class="service-request-page-step1__search-results-list-item-button"
            type="secondary"
          >
            {{ getMain.tabs.tab2.labels.select }}
          </BaseButton>
          <BaseButton
            class="service-request-page-step1__search-results-list-item-button-active"
            type="secondary"
          >
            <SuccessIcon />
            {{ getMain.selectedDealerText }}
          </BaseButton>
        </div>
        </div>
        <div
          v-if="isShowMoreButton"
          class="service-request-page__more"
          @click="showMoreItems"
        >
          {{ getMain.loadMoreItemsText }}
          <MoreIcon />
        </div>
      </div>
      <div
        v-show="choiceSearch === 0"
        class="service-request-page-step1__map-wrapper"
      >
        <div class="service-request-page-step1__map-toggle-wrapper">
          <button
            v-if="!isDesktop"
            class="service-request-page-step1__map-toggle"
            @click="isMapExpandedMobile = !isMapExpandedMobile"
          >
            {{ isMapExpandedMobile ? hideMapText : showMapText }}
          </button>
        </div>
        <div
          class="service-request-page-step1__map-inner"
          :class="{ 'map-inner-hidden': !isDesktop && !isMapExpandedMobile }"
        >
          <div
            class="service-request-page-step1__map map"
            :class="{ 'map-visible': showMap }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters, mapState } from 'vuex'
  import GeoIcon from '@/assets/img/icons/geo.svg?inline'
  import Geo2Icon from '@/assets/img/icons/geo2.svg?inline'
  import SuccessIcon from '@/assets/img/icons/success.svg?inline'
  import MoreIcon from '@/assets/img/icons/more.svg?inline'
  import IconArrow from '@/assets/img/icons/arrow-long-right.svg?inline'
  import SearchField from '@/components/main/SearchField.vue'
  import { getDistanceBetweenTwoPoints } from '@/helpers/helpers'
  import debounce from 'lodash/debounce'
  import { shuffle } from 'lodash'

  export default {
    name: 'Step1',

    components: {
      SearchField,
      IconArrow,
      GeoIcon,
      Geo2Icon,
      SuccessIcon,
      MoreIcon
    },
    props: {
      form: [Object, String],
      dealerItems: Array,
      title: String,
      hint: String,
      activeLoading: Boolean,
      doneStepIndex: Number,
      showroom: String,
      errorMsgs: Object,
      submitForm: Function,
      changeFieldMap: Function,
      resetStep: Function
    },

    data () {
      return {
        showMap: false,
        isMapExpandedMobile: false,
        activeItemIndex: '',
        inputSearch: '',
        error: false,
        language: this.$store.state.currentLang,
        country: this.$store.state.currentCountry,
        currentGeoLocation: {
          latitude: 0,
          longitude: 0
        },
        items: [],
        markers: [],
        page: 1,
        perPage: 4,
        totalCount: 0,
        pageCount: 0,
        choiceSearch: 0,
        debouncedGetDealersCity: null,
        currentCancelToken: null,
        showMoreButton: false,
        geoDenied: false
      }
    },
    computed: {
    ...mapGetters(['getMain', 'isShow', 'getPhoneType']),
    ...mapState({
      currentLang: state => state.currentLang,
      currentCountry: state => state.currentCountry
    }),
    isDesktop () {
      return this.$store.state.deviceSize.width >= 1200
    },
    showMapText () {
      return (this.getMain.tabs && this.getMain.tabs.tab2 && this.getMain.tabs.tab2.labels && this.getMain.tabs.tab2.labels.showMap) || 'Показати мапу'
    },
    hideMapText () {
      return (this.getMain.tabs && this.getMain.tabs.tab2 && this.getMain.tabs.tab2.labels && this.getMain.tabs.tab2.labels.hideMap) || 'Сховати мапу'
    },
    scheduleTitle () {
      return (this.getMain.tabs && this.getMain.tabs.tab2 && this.getMain.tabs.tab2.labels && this.getMain.tabs.tab2.labels.worktime) || 'Графік роботи:'
    },
    isShowMoreButton () {
      return this.items.length < this.totalCount
    }
    },

    watch: {
      choiceSearch () {
        if (this.currentCancelToken) {
          this.currentCancelToken.cancel()
        }
        this.error = false
        this.inputSearch = ''
        this.resetPagination()
        this.showMap = false

        this.items = []
        this.markers = []
        if (this.map) {
          this.map.clearMarkers()
        }
      },
      inputSearch (newVal) {
        this.error = false
        if (this.currentCancelToken) {
          this.currentCancelToken.cancel()
        }
        if (this.choiceSearch === 1 && newVal.length >= 3) {
          this.debouncedGetDealersCity(newVal)
        } else {
          this.debouncedGetDealersCity.cancel()
        }
      }
    },

    mounted () {
      this.initMap()
      this.initAutoComplete()
    },
    created () {
      this.debouncedGetDealersCity = debounce((val) => {
        this.getAllDealersCity(true, val)
      }, 350)
    },

    methods: {
      getDistanceBetweenTwoPoints,
      resetPagination () {
        this.page = 1
        this.pageCount = 0
        this.totalCount = 0
      },
      handleSearch () {
        if (this.inputSearch.length) {
          this.resetPagination()
          if (this.map) {
            this.map.clearMarkers()
          }
          this.getAllDealersCity(false, this.inputSearch)
        }
      },
      onSearchCity () {
        if (this.map) {
          this.map.clearMarkers()
          this.$nextTick()
        }
        this.autocomplete.enable()
        this.items = []

        this.choiceSearch = 0
        this.error = false
        document.querySelector(
          '.toyota-maps-autocomplete-wrapper'
        ).style.opacity = 1
        document.querySelector(
          '.toyota-maps-autocomplete-wrapper'
        ).style.zIndex = 1
      },
      onSearchDP () {
        if (this.map) {
          this.map.clearMarkers()
          this.$nextTick()
        }
        this.autocomplete.disable()

        this.items = []

        this.choiceSearch = 1
        this.error = false
        document.querySelector(
          '.toyota-maps-autocomplete-wrapper'
        ).style.opacity = 0
        document.querySelector(
          '.toyota-maps-autocomplete-wrapper'
        ).style.zIndex = 0
      },
      animateMarker (index) {
        this.map.markers.forEach(marker => {
          marker.element.classList.remove('marker-animate')
        })
        if (this.map.markers[index].element) {
          this.map.markers[index].element.classList.add('marker-animate')
        }

        if (!this.map.markers && !this.map.markers[index]) return
        this.map.markers[index].animate()
      },
      showMoreItems () {
        this.activeLoading = true
        if (this.page < this.pageCount) {
          this.page++
          if (this.choiceSearch === 0) {
            this.getAllDealers()
          }
          if (this.choiceSearch === 1) {
            this.getAllDealersCity(this.choiceSearch === 1, this.inputSearch)
          }
        }
      },
      async onMarkerClick (index, type) {
        if (type === 'list') {
          if (window.parent) {
            window.parent.postMessage({ scrollToIframe: true }, '*')
          }
          const scrollContainer = document.querySelector('.service-page')
          if (scrollContainer) {
            scrollContainer.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          }
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }
        await this.changeFieldMap(this.items[index].id, this.items[index]._source, false)
        this.$nextTick()
        const $el = this.items[index]._source
        if ($el) {

          if (this.choiceSearch === 0) {
            if (!$el.addresses[0]) {
              return console.error('No address')
            }
            this.map._mboxMap.flyTo({
              duration: 1000,
              center: [$el.addresses[0].geoLocation.lon, $el.addresses[0].geoLocation.lat],
              zoom: 14
            })
            this.animateMarker(index)
          }
          this.activeItemIndex = index
        }
      },

      async initMap () {
        const $map = this.$el.querySelector('.map')
        if (!$map) return
        this.map = await new window.mapsWrapper.DynamicMap($map, {
          accessToken: this.getMain.tabs.tab2.labels.mapboxKey,
          language: this.language,
          countryCode: this.country,
          addCountryBoundaries: this.country,
          zoomControl: this.$resp.sm ? 'top-left' : 'bottom-right',
          maxZoom: 15
        })
      },

      async getCurrentGeoLocation () {
        if (navigator.permissions) {
          try {
            const status = await navigator.permissions.query({ name: 'geolocation' })
            if (status.state === 'denied') {
              this.geoDenied = true
              return
            }
          } catch (e) {}
        }

        this.geoDenied = false

        if (this.map) {
          this.map.clearMarkers()
          this.$nextTick()
        }
        this.$emit('set-dealer', '')
        this.activeItemIndex = ''
        this.choiceSearch = 0
        this.error = false

        try {
          const currentlocation = await this.map.getCurrentGeoLocation()

          if (currentlocation.length) {
            this.currentGeoLocation.latitude = currentlocation[1]
            this.currentGeoLocation.longitude = currentlocation[0]
          }

          const [location] = await this.map.geoReverse(currentlocation, {
            fitToBounds: true,
            limit: 1,
            language: this.language
          })

          if (location instanceof Object && location.name) {
            this.inputSearch = location.name
          }

          const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          }

          const success = async pos => {
            await this.getAllDealers()
            const crd = pos.coords
            this.currentGeoLocation.latitude = crd.latitude
            this.currentGeoLocation.longitude = crd.longitude
          }

          const error = (err) => {
            console.warn(`ERROR(${err.code}): ${err.message}`)
            if (err.code === 1) {
              this.geoDenied = true
            }
          }

          navigator.geolocation.getCurrentPosition(success, error, options)
        } catch (e) {
          console.error('getCurrentGeoLocation failed:', e)
        }
      },

      async getAllDealers (distance = '50km') {
        const distances = ['50km', '100km', '150km']
        this.$emit('set-dealer', '')
        this.activeItemIndex = ''

        try {
          const jsonData = {
            query: {
              bool: {
                must: {
                  term: {
                    'brands.raw': 'Toyota'
                  }
                },
                filter: {
                  geo_distance: {
                    distance,
                    'addresses.geoLocation': {
                      lat: this.currentGeoLocation.latitude,
                      lon: this.currentGeoLocation.longitude
                    }
                  }
                }
              }
            }
          }
          const CancelToken = axios.CancelToken

          this.currentCancelToken = CancelToken.source()

          const { data } = await window.axios.post(
            `/dealer/dealers-api?page=${this.page}&per_page=${this.perPage}`,
            jsonData,
            {
              headers: {
                Token: `${this.getMain['access-token']}`
              },
              cancelToken: this.currentCancelToken.token
            }
          )

          const hits = data.hits.hits

          if (!hits.length) {
            const currentIndex = distances.indexOf(distance)
            if (currentIndex < distances.length - 1) {
              return this.getAllDealers(distances[currentIndex + 1])
            }
          }

          if (this.page === 1) {
            this.items = hits
          } else {
            this.items = [...this.items, ...hits]
          }
          if (!data.hits.hits.length) {
            this.error = true
          }
          if (data.pagination) {
            this.totalCount = data.pagination.totalCount
            this.pageCount = data.pagination.pageCount
          }

          await this.getNearMarkers()
        } catch (e) {
        }
      },

      async getAllDealersCity (isDealerSearch, inputVal) {
        this.$emit('set-dealer', '')
        this.activeItemIndex = ''
        this.$emit('update:activeLoading', true)
        const filter = !isDealerSearch ? {
          geo_distance: {
            distance: '2000km',
            'addresses.geoLocation': {
              lat: this.currentGeoLocation.latitude || 50.272796,
              lon: this.currentGeoLocation.longitude || 30.31428
            }
          }
        } : {}
        const jsonData = {
          query: {
            bool: {
              must: {
                term: {
                  'brands.raw': 'Toyota'
                }
              },
              filter: {
              ...filter
              }
            }
          }
        }

        const CancelToken = axios.CancelToken

        this.currentCancelToken = CancelToken.source()

        try {
          const { data } = await window.axios.post(
            `/dealer/dealers-api?page=${this.page}&per_page=${this.perPage}&name=${inputVal}`,
            jsonData,
            {
              headers: {
                Token: `${this.getMain['access-token']}`
              },
              cancelToken: this.currentCancelToken.token
            }
          )
          const hits = shuffle(data.hits.hits)
          if (this.page === 1) {
            this.items = hits
          } else {
            this.items = [...this.items, ...hits]
          }
          this.activeItemIndex = null

          if (!data.hits.hits.length) {
            this.error = true
          }

          if (data.pagination) {
            this.totalCount = data.pagination.totalCount
            this.pageCount = data.pagination.pageCount
          }
          this.$emit('update:activeLoading', false)
          await this.getNearMarkers(false)
          this.$emit('update:activeLoading', false)
        } catch (e) {
          this.$emit('update:activeLoading', false)

          if (e.name === 'CanceledError') {
            return
          }
          console.log(e)
        }
      },

      async getNearMarkers (sortByGeo = true) {
        if (!this.showMap) this.showMap = true
        if (!this.map) return

        this.map.clearMarkers()

        this.items = this.items
          .map(item => {
            const distance = this.getDistanceBetweenTwoPoints(
              {
                lat: item._source.addresses[0].geoLocation.lat,
                lon: item._source.addresses[0].geoLocation.lon
              },
              {
                lat: this.currentGeoLocation.latitude,
                lon: this.currentGeoLocation.longitude
              }
            )
            return { ...item, distance }
          })

        if (sortByGeo) {
          this.items.sort((a, b) => a.distance - b.distance)
        }

        this.markers = this.items.map(dealer => ({
          lat: dealer._source.addresses[0].geoLocation.lat,
          lon: dealer._source.addresses[0].geoLocation.lon,
          title: dealer._source.name
        }))

        await this.map.addMarkers(this.markers, {
          markerImage: 'toyota-red-text',
          text: true,
          markerClick: this.onMarkerClick
        })

        await this.map.fitBoundsToMarkers({ maxZoom: 13 })
      },
      async initAutoComplete () {
        this.autocomplete = new window.mapsWrapper.AutoComplete({
          autoCompleteInput: this.$refs.SearchField.$el.querySelector('input'),
          countryCode: this.country,
          minLength: 3,
          delay: 500,
          language: this.language,
          types: ['place', 'locality', 'neighborhood', 'region', 'postcode'],
          onLocationSelect: async location => {
            if (this.choiceSearch === 1) return

            if (location instanceof Object) {
              [
                this.currentGeoLocation.longitude,
                this.currentGeoLocation.latitude
              ] = location.coordinates
              this.resetPagination()
              if (this.map) {
                this.map.clearMarkers()
              }
              await this.getAllDealers()
              this.error = false
            } else {
              this.error = true
            }
          },
          accessToken: this.getMain.tabs.tab2.labels.mapboxKey
        })

        this.$nextTick(() => {
          const wrapper = document.querySelector('body > .toyota-maps-autocomplete-wrapper')
          if (wrapper) {
            const inputContainer = this.$el.querySelector('.service-request-page__input')
            inputContainer.appendChild(wrapper)
          }

          const servicePage = document.querySelector('.service-page')
          if (servicePage) {
            servicePage.addEventListener('scroll', (e) => {
              e.stopPropagation()
            }, true)
          }
        })
      },
      clearSearch () {
        this.map.clearMarkers()
        this.$emit('set-dealer', '')
        this.error = false
        this.items = []
        this.autocomplete.clearSuggestions()
        this.inputSearch = ''
        this.activeItemIndex = ''
        this.markers = []
        this.showMap = false
        this.resetStep()
        this.resetPagination()
      },
      getWorkshopAddress (item) {
        if (
          !item ||
          !item._source ||
          !item._source.addresses ||
          !item._source.addresses.length
        ) {
          return null
        }

        const addresses = item._source.addresses

        const workshopAddress = addresses.find(function (adr) {
          if (!adr || !Array.isArray(adr.operations)) return false

          return adr.operations.some(function (op) {
            return String(op).toLowerCase() === 'workshop'
          })
        })

        if (workshopAddress) {
          return workshopAddress
        }

        return addresses[0]
      } }
  }
</script>

<style lang="scss">
hr {
  border-top: 1px solid $c-gray-8;
  margin: 0;
}

.service-request-page {
  &__top {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 24px;
    padding-bottom: 32px;

    @media (max-width: 1200px) {
      padding-bottom: 24px;
      gap: 0;
    }

    @include mobile {
      align-items: stretch;
    }
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;

    @media (max-width: 1200px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    @media (max-width: 767px) {
      margin-bottom: 16px;
    }
  }

  &__checkboxes {
    display: flex;
    align-items: center;
    gap: 29px;

    @media (max-width: 1200px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }

  &__checkbox {
    display: flex;
    gap: 14px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;

    .radio {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid $c-gray-6;
      font-family: 'ToyotaType', sans-serif;
      letter-spacing: 0.14px;
      margin: 0;
    }

    span {
      font-family: 'ToyotaType', sans-serif;
      font-weight: 400;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.1px;
      color: $c-gray-dark;
    }

    &.active {
      .radio {
        position: relative;
        border: 1px solid $c-gray-dark;
        //color: $c-black-primary;

        &:after {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          content: '';
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: $c-gray-dark;
          margin: auto;
        }
      }
    }
  }

  &__geo {
    position: relative;
    top: 2px;
    cursor: pointer;
    display: flex;
    gap: 8px;
    align-items: center;
    font-family: 'ToyotaType', sans-serif;
    letter-spacing: 0.1px;
    font-size: 13px;
    line-height: 20px;
    font-weight: 400;
    background: transparent;
    border: none;
    color: $c-gray-dark;
    padding-bottom: 5px;

    span {
      //color: $c-black-primary;
    }

    span:first-child {
      text-decoration: underline;
    }

    @media (max-width: 1200px) {
      order: -1;
      margin-bottom: 2px;
    }
  }

  &__input {
    position: relative;
    max-width: 364px;
    width: 100%;

    @media (max-width: 1200px) {
      max-width: 100%;
    }

    .toyota-maps-autocomplete-wrapper {
      position: static;

      ul {
        position: absolute !important;
        top: 100% !important;
        left: 0 !important;
        right: 0 !important;
        width: auto !important;
        z-index: 100;
      }
    }
  }

  &__button {
    &.button_disabled {
      opacity: 1;
      //background: $c-gray-titan;
    }
  }

  .service-request-page-step1__map-wrapper {
    padding-top: 32px;
    padding-right: 44px;

    @media (max-width: 1199px) {
      width: 100%;
      padding-top: 24px;
      padding-right: 0;
    }

    @include mobile {
      padding-top: 22px;
    }
  }

  .service-request-page-step1__map-toggle-wrapper {
    display: flex;
    justify-content: center;
  }

  .service-request-page-step1__map-toggle {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'ToyotaType', sans-serif;
    font-weight: 400;
    font-size: 16px;
    padding-top: 12px;
    line-height: 24px;
    color: $c-gray-dark;
    letter-spacing: -0.2px;
    //color: $c-black-mind;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: $c-gray-dark;
    }
  }

  .service-request-page-step1__map-inner {
    @media (max-width: 1199px) {
      display: grid;
      //grid-template-rows: 610px;
      transition: grid-template-rows 0.4s ease, opacity 0.4s ease, margin 0.4s ease;
      opacity: 1;
      margin-top: 24px;
    }
  }

  .map-inner-hidden {
    @media (max-width: 1199px) {
      grid-template-rows: 0;
      opacity: 0;
      margin-top: 0;
      overflow: hidden;
    }
  }

  .service-request-page-step1__map {
    height: 610px;
    width: 558px;
    box-shadow: 0 4px 12px 0 #0000001f;
    border-radius: 8px;
    overflow: hidden;

    @media (max-width: 1200px) {
      width: 100%;
      height: 340px;
      min-height: 0;
    }

    @include mobile {
      height: 340px;
    }
  }

  .service-request-page-step1__list-column {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;

    @media (max-width: 1200px) {
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
    }
  }

  .service-request-page-step1__search-results-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    cursor: pointer;
    width: 100%;
    gap: 24px;
    max-height: 750px;
    overflow-y: auto;
    align-content: start;
    max-width: 620px;
    padding-left: 44px;
    padding-right: 16px;
    padding-bottom: 25px;
    margin-top: 32px;

    /* Force custom scrollbar always visible on macOS */
    &:hover,
    & {
      scrollbar-width: thin;
      scrollbar-color: $c-gray-6 transparent;
    }

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 4px;
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $c-gray-6;
      border-radius: 6px;
    }

    @media (max-width: 1200px) {
      max-height: none;
      max-width: 100%;
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      gap: 16px;
      margin-top: 24px;
      overflow-y: visible;
    }

    @include mobile {
      grid-template-columns: repeat(1, 1fr);
      padding-bottom: 16px;
    }

    &.without-map {
      max-width: 100%;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: unset;
      margin-bottom: 24px;
      padding-right: 44px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 16px;
        gap: 16px;
        padding-right: 0;
      }

      @media (max-width: 767px) {
        grid-template-columns: 1fr;
      }
    }
  }

  .map {
    position: relative;
    opacity: 0 !important;
    visibility: hidden !important;
    transition: 0.35s !important;
    //transition-delay: 1s!important;
  }

  .map-visible {
    opacity: 1 !important;
    //transition-delay: 1s!important;
    visibility: visible !important;
  }

  .service-request-page-step1__search-results-list-item {
    padding: 24px;
    display: flex;
    flex-direction: column;
    border: 1px solid $c-gray-light;
    background: $c-white;
    border-radius: 4px;
    box-shadow: 0 15px 80px 0 rgba(0, 0, 0, 0.04), 0 4.522px 24.118px 0 rgba(0, 0, 0, 0.05), 0 1.878px 10.017px 0 rgba(0, 0, 0, 0.03), 0 0.679px 3.623px 0 rgba(0, 0, 0, 0.02);

    &.active {
      padding-bottom: 0;

      .service-request-page-step1__search-results-list-item-index {
        background: $c-green;
        border-color: $c-green;
        color: $c-white;
      }

      .service-request-page-step1__search-results-list-item-button {
        display: none;
      }

      .service-request-page-step1__search-results-list-item-button-active {
        display: flex;
      }

      .service-request-page-step1__search-results-list-item-name {
        display: block;
        -webkit-line-clamp: unset;
        overflow: visible;
      }
    }
  }

  .service-request-page-step1__search-results-list-item-title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    font-family: 'ToyotaType', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.35px;
    color: $c-gray-dark;
    margin-bottom: 0;
    padding-bottom: 8px;
    border-bottom: 1px solid $c-gray-4;
    min-height: 70px;

    @include mobile {
      min-height: auto;
    }
  }

  .service-request-page-step1__search-results-list-item-name {
    @media only screen and (min-width: $l) {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .service-request-page-step1__search-results-list-item-index {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    flex-grow: 0;
    border: 2px solid $c-gray-dark;
    background: $c-gray-1;
    border-radius: 50%;
    font-family: 'ToyotaType', sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.14px;
    margin-top: -1px;
  }

  .service-request-page-step1__search-results-list-item-distance {
    font-family: 'ToyotaType', sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 1px;
    gap: 4px;
    display: flex;
    align-items: center;
    margin-top: auto;
    margin-bottom: 16px;
    padding-top: 32px;

    @include tablet {
      padding-top: 16px;
    }
  }

  .service-request-page-step1__search-results-list-item-empty-space {
    margin-top: auto;
    margin-bottom: 16px;
  }

  .service-request-page-step1__search-results-info-description {
    font-family: 'ToyotaType', sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: -0.5px;
    color: $c-gray-7;
  }

  .service-request-page-step1__schedule {
    margin-top: 7px;
  }

  .service-request-page-step1__schedule-title {
    font-family: 'ToyotaType', sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.4px;
    //color: $c-black;
    margin-bottom: 6px;
  }

  .service-request-page-step1__schedule-line {
    & > div > div {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    p {
      font-family: 'ToyotaType', sans-serif;
      font-weight: 400;
      font-size: 10px;
      line-height: 16px;
      letter-spacing: 0;
      color: $c-gray-dark;
      display: flex;
      align-items: center;

      span {
        color: $c-gray-7;
        border-left: 1px solid $c-gray-dark;
        padding-left: 8px;
        margin-left: 6px;
        line-height: 12px;
        height: 12px;
      }
    }
  }

  &__inner {
    gap: 8px;
    display: flex;
    margin: 0 -44px;

    @media (max-width: 1200px) {
      flex-direction: column-reverse;
      margin: 0;
      gap: 16px;
    }
  }

  .service-request-page-step1__search-results-list-item-button {
    display: flex;
    font-family: 'ToyotaType', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    background: transparent;
    border: 1px solid $c-gray-dark;
    border-radius: 0;
    padding-left: 8px;
    padding-right: 8px;
    justify-content: center;

    svg path {
      //fill: $c-azure;
    }

    &:focus {
      //background: $c-azure;
      color: $c-white;

      svg path {
        fill: $c-white;
      }
    }

    @include hover {
      &:hover {
        background: $c-gray-dark;
        color: $c-white;

        svg path {
          fill: $c-white;
        }
      }
    }
  }

  .service-request-page-step1__search-results-list-item-button-active {
    display: none;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    font-family: 'ToyotaType', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.14px;
    background: $c-green;
    border: 1px solid $c-green;
    position: relative;
    width: calc(100% + 48px) !important;
    color: $c-white;
    left: -24px;
    border-radius: 0;
    padding-left: 12px;

    &:hover,
    &:focus {
      background: $c-green !important;
      color: $c-white !important;
    }
  }

  .toyota-marker .main {
    fill: $c-black;
    stroke: $c-black;
    stroke-width: 3px;
  }

  .marker-animate .main {
    fill: $c-white;
  }

  .marker-animate text {
    fill: $c-black;
  }

  .service-request-page__more {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    font-family: 'ToyotaType', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin-left: 32px;
    margin-top: 24px;

    @include tablet {
      margin-left: 0;
      margin-top: 0;
    }
  }
}

.service-request-page-step1__location-block-error {
  font-family: 'ToyotaType', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: $c-gray-7;
  padding: 15px 0 15px 44px;

  @media (max-width: 1200px) {
    padding-left: 0;
  }
}

.service-request-page-step1 .service-request-page__button {
  margin-top: 0;

  @include tablet {
    margin-top: 24px;
  }

  @include mobile {
    margin-top: 10px;
  }
}

</style>
